export default "__VITE_ASSET__2UH0s8FV__"